import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";
const Portfolio = () => {
  // init one ref to store the future isotope object
  const isotope = useRef();
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setimagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();
  const [isOpen, setIsOpen] = useState(false);

  const htmlElement = document.getElementsByTagName("html")[0];
  const isRtl = htmlElement.getAttribute("dir") === "rtl";

  const types = {
    DOCUMENT: "document",
  };

  const projectsData = [
    {
      title: "How a $500M Manufacturing Firm Cut Invoice Processing Time by 95% with AI Automation",
      type: types.DOCUMENT,
      document: {
        client: "A leading regional provider of industrial components.",
        industry: "Manufacturing",
        challenge: "The client's manual accounts payable process was slow and error-prone, involving three full-time employees and leading to an average payment cycle of 15 days, resulting in missed early payment discounts and significant labor costs.",
        solution: "I designed and deployed a custom AI-powered document processing system. The solution utilized optical character recognition (OCR) and a machine learning model to automatically extract and validate invoice data, which was then seamlessly integrated with their existing SAP ERP system.",
        results: [
          "95% reduction in manual invoice processing time",
          "From 15 days to 2 days average payment cycle",
          "40+ hours per week of staff time reallocated to higher-value tasks",
          "$75,000 in annual savings from capturing early payment discounts",
          "Estimated 300% ROI within the first 12 months"
        ],
        sliderImages: [
          "images/projects/project-1.jpg",
          "images/projects/project-2.jpg",
        ],
      },
      thumbImage: "images/projects/project-1.jpg",
      categories: ["DETAILED"],
    }
  ];

  // initialize an Isotope object with configs
  useEffect(() => {
    isotope.current = new Isotope(".portfolio-filter", {
      itemSelector: ".filter-item",
      layoutMode: "masonry",
      originLeft: !isRtl,
    });

    // cleanup
    return () => {
      isotope.current.destroy();
    };
  }, []);

  // handling filter key change
  useEffect(() => {
    if (imagesLoaded) {
      isotope.current.arrange({ filter: `*` });
    }
  }, [imagesLoaded]);

  return (
    <>
      <section id="portfolio" className={"section bg-light"}>
        <div className={"container"}>
          {/* Heading */}
          <p className="text-center mb-2 wow fadeInUp">
            <span className="bg-primary text-dark px-2">Case Studies</span>
          </p>
          <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
            A Narrative of Problem, Solution, and Measurable Impact
          </h2>
          {/* Heading end*/}
          
          <div className="portfolio wow fadeInUp">
            <div className="row portfolio-filter filter-container g-4">
              {projectsData.length > 0 &&
                projectsData.map((project, index) => (
                  <div
                    className={
                      "col-sm-6 col-lg-4 filter-item "
                    }
                    key={index}
                  >
                    <div className="portfolio-box">
                      <div className="portfolio-img">
                        <img
                          onLoad={() => {
                            setimagesLoaded(imagesLoaded + 1);
                          }}
                          className="img-fluid d-block portfolio-image"
                          src={project.thumbImage}
                          alt=""
                        />
                        <div
                          className="portfolio-overlay"
                          onClick={() => {
                            setSelectedProjectDetails(projectsData[index]);
                            setIsOpen(true);
                          }}
                        >
                          <button className="popup-ajax stretched-link border-0 p-0 ">
                            {" "}
                          </button>
                          <div className="portfolio-overlay-details">
                            <p className="text-primary text-8">
                              {project.type === types.DOCUMENT && (
                                <i className="fas fa-file-alt"></i>
                              )}
                            </p>
                            <h5 className="text-white text-5">
                              {project?.title}
                            </h5>
                            <span className="text-light">Category</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      {/* Modal */}
      {isOpen && (
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          setIsOpen={setIsOpen}
        ></ProjectDetailsModal>
      )}
    </>
  );
};

export default Portfolio;
